<template>
  <div ref="wrapper" class="hint-desktop">
    <HintMessage
      class="hint-desktop__message"
      :message="message"
      :is-open="isOpen"
      :wrapper-position="wrapperPosition"
      @mouseenter="setHoveredOnMessage(true)"
      @mouseleave="setHoveredOnMessage(false)"
    />
    <HintSign
      :radius="radius"
      :stroke-width="strokeWidth"
      :delay-in-seconds="delayInSeconds"
      :is-open="isOpen"
      :hovered="hovered"
      @mouseenter="setHoveredOnSign(true)"
      @mouseleave="setHoveredOnSign(false)"
    />
  </div>
</template>

<script>
import HintSign from './HintSign';
import HintMessage from './HintMessage';

const RADIUS = 8;
const STROKE_WIDTH = 2;
const DELAY_IN_SECONDS = 0.5;

const HOVER_SWAP_TIME_IN_MILISECONDS = 50;

export default {
  components: {
    HintSign,
    HintMessage,
  },
  props: {
    message: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      timer: null,
      isOpen: false,
      hoveredOnMessage: false,
      hoveredOnSign: false,
      wrapperPosition: {
        left: 0,
        top: 0,
      },
    };
  },
  computed: {
    hovered() {
      return this.hoveredOnMessage || this.hoveredOnSign;
    },
    radius() {
      return RADIUS;
    },
    strokeWidth() {
      return STROKE_WIDTH;
    },
    delayInSeconds() {
      return DELAY_IN_SECONDS;
    },
  },
  watch: {
    hoveredOnSign() {
      this.calculatePosition();
    },
    hovered() {
      if (this.hovered) {
        const timerDelay = this.delayInSeconds * 1000;
        this.timer = setTimeout(() => {
          this.isOpen = true;
        }, timerDelay);
      } else {
        clearTimeout(this.timer);

        this.isOpen = false;
      }
    },
  },
  mounted() {
    this.calculatePosition();
  },
  methods: {
    calculatePosition() {
      const {
        top,
        left,
        right,
        bottom,
      } = this.$refs.wrapper.getBoundingClientRect();

      this.wrapperPosition.top = top;
      this.wrapperPosition.left = left;
      this.wrapperPosition.right = right;
      this.wrapperPosition.bottom = bottom;
    },
    setHoveredOnMessage(hovered) {
      if (!this.isOpen || hovered) {
        this.hoveredOnMessage = hovered;
      } else {
        setTimeout(() => {
          this.hoveredOnMessage = false;
        }, HOVER_SWAP_TIME_IN_MILISECONDS);
      }
    },
    setHoveredOnSign(hovered) {
      if (!this.isOpen || hovered) {
        this.hoveredOnSign = hovered;
      } else {
        setTimeout(() => {
          this.hoveredOnSign = false;
        }, HOVER_SWAP_TIME_IN_MILISECONDS);
      }
    },
  },
};
</script>

<style lang="scss">
.hint-desktop {
  display: inline-block;
  position: relative;

  &__message {
    position: absolute;
  }
}

button .hint-desktop {
  vertical-align: middle;
}
</style>
